import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 37,
	height: 37,
	fill: "none",
	viewBox: "0 0 37 37",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M24.664 6.746H12.79v.742a.742.742 0 0 1-1.484 0v-.742H9.081c-1.23 0-2.226.996-2.226 2.226v3.71H30.6v-3.71c0-1.23-.997-2.226-2.226-2.226h-2.226v.742a.742.742 0 0 1-1.484 0zm1.484-1.484h2.226a3.71 3.71 0 0 1 3.71 3.71v19.304a3.71 3.71 0 0 1-3.71 3.71H9.081a3.71 3.71 0 0 1-3.71-3.71V8.972a3.71 3.71 0 0 1 3.71-3.71h2.226v-.743a.742.742 0 1 1 1.484 0v.743h11.873v-.743a.742.742 0 1 1 1.484 0zm4.452 8.904H6.855v14.11c0 1.23.996 2.226 2.226 2.226h19.293c1.23 0 2.226-.997 2.226-2.226z"
	})
});
export default SvgCalendar;
